import {isHTMLElement} from './utils';

export const intersectionMap: Map<
  string,
  (entry: IntersectionObserverEntry) => void
> = new Map();
export const intersectionObserver = new IntersectionObserver(
  (entries, observer) => {
    for (const entry of entries) {
      for (const [selector, handler] of intersectionMap) {
        if (entry.target.matches(selector)) {
          handler(entry);
        }
      }
    }
  },
  {
    threshold: Array.from({length: 1000}, (_, i) => i / 1000),
  },
);

export function getMinIntersectionRatio(target: HTMLElement): number {
  // data-min-intersection-ratio
  const inputMinRatio: string = target.dataset.minIntersectionRatio || '0';
  let minRatio = parseFloat(inputMinRatio);
  if (isNaN(minRatio)) {
    minRatio = 0;
  }
  if (inputMinRatio.endsWith('%')) {
    minRatio /= 100;
  }

  return minRatio;
}

export function getMinIntersectionWidthHeight(target: HTMLElement): {
  width: number;
  height: number;
} {
  // data-min-intersection-width
  // data-min-intersection-height
  return {
    width: parseFloat(target.dataset.minIntersectionWidth || '0'),
    height: parseFloat(target.dataset.minIntersectionHeight || '0'),
  };
}

export function isIntersectionValid(entry: IntersectionObserverEntry): boolean {
  const {target, isIntersecting, intersectionRatio, intersectionRect} = entry;
  if (!isIntersecting || !isHTMLElement(target)) {
    return false;
  }

  const minRatio = getMinIntersectionRatio(target);
  const minWidthHeight = getMinIntersectionWidthHeight(target);
  if (
    intersectionRatio < minRatio ||
    intersectionRect.width < minWidthHeight.width ||
    intersectionRect.height < minWidthHeight.height
  ) {
    return false;
  }

  return true;
}
